import LoadingComponents from './Loading.vue';

const Loading = {
    install:function(Vue) {
        Vue.component('Loading', LoadingComponents)
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/index.js